<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/C4B5UW/images/cover.jpg?1733067571559" alt="This image is the cover for the book How to Survive Almost Anything"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How to Survive Almost Anything
      </h1>
      <p class="bookDescription body article font2">
        <b>Prepare for Whatever Comes Your Way With This Essential Survival Bible</b><p>“This book is your essential kit for every aspect of what life can throw at you…Brilliant.” ─<b>Amazon</b> review</p><p><b>Learn How to Thrive Against All Odds with the Modern Survival Bible from Ex-UK Special Forces specialist Ollie Ollerton</b></p><p><b>Be the master of your survival.</b> In <i>How to Survive (Almost) Anything</i>, former Special Forces soldier and bestselling author Ollie Ollerton passes on all the special skills, knowledge, and mindset he’s learned over the course of a life that has experienced some of the world's toughest conditions and most hostile situations.</p><p><b>A lifeline in uncertain times. </b>This modern-day survival bible empowers you to thrive, not just survive. Whether you're faced with the wild elements of nature, societal collapse, extreme weather, or urban warfare, this guide equips you with essential skills.  Don't leave your survival to chance! Arm yourself with the knowledge and tools to face anything and become the master of your destiny.</p><p><b>Inside you'll discover:</b></p>Survival Techniques: Learn from an ex-UK Special Forces soldier how to fend off wildlife, survive natural  disasters, and navigate man-made challengesMental Resilience: Equip yourself with the mindset to thrive, not just survive, in the face of emergencies and against all oddsPractical Guidance: Ideal for survivalists, prepping enthusiasts, or as a thoughtful dad gift or gift for a teen boy, this guide offers hands-on advice to face any crisis with confidence.<p></p><p><b>If you have read books such as <i>The Lost Art of Reading Nature’s Signs</i>, <i>Extreme Survival</i>, <i>Surviving the Wild</i>, or <i>The Ultimate Prepper's Survival
Bible</i>, you’ll love Ollie Ollerton’s <i>How to Survive (Almost) Anything</i>.</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ollie Patton
      </h2>
      
      <p class="authorDescription body article"><P><B>Matthew 'Ollie' Ollerton</B> is a former Special Forces soldier and a member of the Directing Staff on Channel 4's hit show SAS: Who Dares Wins. Ollie's military career began at the age of 18 when he joined the Royal Marine Commandos and toured operationally in Northern Ireland and in Iraq for Operation Desert  Storm. He subsequently spent six years in the Special Boat Service rising to team leader, before working in Iraq as a private security contractor and carrying out charity work in South-East Asia. Ollie now spends his time as a corporate training entrepreneur for his company Break-Point, an ambassador for the Royal Marines Charity and a director of the mental health charity StrongMen.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Blink Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25bb21d0